import { Component } from '@angular/core';

@Component({
	selector: 'ds-miscellaneous',
	template: `<router-outlet></router-outlet>`,
})
export class MiscellaneousComponent {}
